import { baseApi } from "../../../core/data/rtk/baseQuery";
import { ApiResponseType } from "../../../core/data/rtk/apiResponseType";
import { DashboardResponse } from "../types/DashboardResponse";

export const dashboardApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getDashboardData: builder.query<ApiResponseType<DashboardResponse>, void>({
      query: () => `dashboard/get-data`,
    //   providesTags: ["Dashboard"],
    }),
  }),
});

export const {
    useGetDashboardDataQuery,
} = dashboardApi;
